export default [{
  title: 'created',
  lazy: true,
  items: [{
    name: 'created',
    type: 'code',
    height: '100%',
  }],
}, {
  title: 'mounted',
  lazy: true,
  items: [{
    name: 'mounted',
    type: 'code',
    height: '100%',
  }],
}, {
  title: 'display',
  lazy: true,
  items: [{
    name: 'display',
    type: 'code',
    height: '100%',
  }],
}, {
  title: 'html',
  lazy: true,
  items: [{
    name: 'html',
    language: 'html',
    type: 'code',
    height: '100%',
  }],
}, {
  title: 'style',
  lazy: true,
  items: [{
    name: 'style',
    type: 'code',
    language: 'json',
    height: '100%',
  }],
}];
